// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26EzV","left":"styles_left__3UQXB"};